import React, { useContext } from 'react'
import { useSelector } from 'react-redux';

export const Carrier=({renderForm})=>{
  const dataSource=useSelector((state) => state.Actor.carrier)
  const security = useSelector((state) => state.Shipment.transportation.security);

   const disableForm=security==2
   const errorMessage=React.useMemo(()=>(disableForm && !dataSource.eoriNo && {"eoriNo":["EORI Number is mandatory if selected value of security is 2"]}),[disableForm,dataSource.eoriNo])
   return renderForm ? renderForm({
    errorInfo:errorMessage,
    actorType:"carrier",
    boxNumber:"14",
    disabled:!disableForm,
    actorName:"Carrier Name",
    dataSource:dataSource

   })
   :
   null 
 
}